import React, { useState } from 'react';
import { LogoButton, NavigationBarContainer, Title, Details, Host } from './styles';
import { Button, Modal, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import logo from '../../../../assets/svg/brandingLogo.svg';
import arrow from '../../../../assets/svg/arrow-left.svg';
import { format } from 'date-fns';
import { useClip } from '../../contexts/clip/hook';
import { EditableTitle } from '../EditableTitle';
import { DeleteOutlined, ExclamationCircleFilled, EyeOutlined } from '@ant-design/icons';
import { useToast } from '../../../../hooks/useToast';
import { ShareBox } from '../ShareBox';

const { confirm } = Modal;

export const NavigationBar: React.FC = () => {
  const { clip, isOwner, deleteClip } = useClip();
  const { success, error } = useToast();

  const navigate = useNavigate();

  const [hoveredLogo, setHoveredLogo] = useState(false);

  const goToRecaps = () => {
    navigate('/clips');
  };

  return (
    <NavigationBarContainer>
      <Space>
        <LogoButton
          onClick={goToRecaps}
          onMouseEnter={() => setHoveredLogo(true)}
          onMouseLeave={() => setHoveredLogo(false)}
        >
          <img src={hoveredLogo ? arrow : logo} />
        </LogoButton>

        <Title>
          <EditableTitle />
          <Details>
            <div>
              {clip.createdAt && format(new Date(clip.createdAt), 'eeee, MMMM d, yyyy h:mma')}
            </div>
            <div style={{ paddingLeft: '16px', paddingRight: '16px' }}>|</div>
            <div style={{ fontFamily: 'Cera Pro Medium' }}>Owner</div>
            <Host>: {clip.owner}</Host>
            <div style={{ paddingLeft: '16px', paddingRight: '16px' }}>|</div>
            <div style={{ fontFamily: 'Cera Pro Medium' }}>Host</div>
            <Host>: {clip.host}</Host>
          </Details>
        </Title>
      </Space>

      {isOwner && (
        <Space style={{ paddingRight: '24px' }}>
          <div>
            {clip.views} <EyeOutlined />
          </div>
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => {
              confirm({
                title: 'Are you sure you want to delete this clip?',
                icon: <ExclamationCircleFilled />,
                content: "Deleting a clip is an irreversible action, this can't be undone",
                okText: 'Yes, Delete',
                okType: 'danger',
                cancelText: 'No',
                onOk: async () => {
                  try {
                    await deleteClip();
                    success('Clip deleted successfully');
                    navigate('/clips');
                  } catch (err) {
                    console.error('Error deleting clip:', err);
                    error('Failed to delete clip');
                  }
                },
              });
            }}
          >
            Delete
          </Button>
          <ShareBox />
        </Space>
      )}
    </NavigationBarContainer>
  );
};
